// External personnel (/external-personnel-management). Stored values are shown
// as typed; the Excel headers are the Turkish field names.
const externalPersonnel = {
  page: {
    title: 'External Personnel',
    subtitle: 'Contact and role details of external staff (investigators, coordinators, etc.).',
  },
  actions: {
    excel: 'Download Table',
    excelHint: 'Download all external personnel with the columns shown in the table as Excel',
    add: 'Add External Personnel',
  },
  stats: {
    total: 'Total External Personnel',
    totalShort: 'Total',
    active: 'Active Personnel',
    activeShort: 'Active',
    inactive: 'Inactive Personnel',
    inactiveShort: 'Inactive',
    share: '{{percent}}% of personnel',
  },
  toolbar: {
    search: 'Search by name, surname or phone…',
    searchShort: 'Search personnel…',
    status: 'Status',
    all: 'All',
  },
  status: {
    aktif: 'Active',
    inaktif: 'Inactive',
  },
  fields: {
    name: 'First Name',
    surname: 'Last Name',
    address: 'Address',
    phone: 'Phone',
    email: 'E-mail',
    institution: 'Institution',
    title: 'Title',
    specialty: 'Specialty',
    department: 'Department',
    personnelType: 'Personnel Type',
    status: 'Status',
    info: 'Info',
  },
  table: {
    listLabel: 'External personnel',
    empty: 'No personnel match the filters',
    rangeOf: 'of {{total}} people',
    ofTotal: 'out of {{total}} people',
    jump: 'Go to page',
  },
  panel: {
    label: 'Selected personnel',
    heading: 'External personnel',
    edit: 'Edit',
  },
  form: {
    newTitle: 'Add External Personnel',
    editTitle: 'Edit External Personnel',
    subtitle: 'All fields are required.',
    sections: {
      contact: 'Person and contact',
      work: 'Institution and role',
    },
    required: 'This field is required',
    missing: 'Missing information — please fill in: {{fields}}',
  },
  common: {
    cancel: 'Cancel',
    save: 'Save',
  },
  toast: {
    loadError: 'Error loading external personnel',
    added: 'External personnel added!',
    addError: 'Error adding the external personnel!',
    updated: 'External personnel updated!',
    updateError: 'Error updating the external personnel!',
    excelPreparing: 'Preparing the Excel file…',
    excelDone: 'Excel file downloaded successfully',
    excelError: 'Error downloading the file',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default externalPersonnel;
